"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVector2dElementwise = void 0;
var updateVector2dElementwise = function (from, updateFn) {
    return from.withMutations(function (rect) { return rect.update('x', updateFn).update('y', updateFn); });
};
exports.updateVector2dElementwise = updateVector2dElementwise;
